import { CT_PERSONALIZATION_TYPES, CT_PERSONALIZATION_CTA_TEXT } from './constants';

export const getCtaText = (contentTileType, modelName) => {
  switch (contentTileType) {
    case CT_PERSONALIZATION_TYPES.MLP:
      return `${CT_PERSONALIZATION_CTA_TEXT.mlp} ${modelName}`;
    case CT_PERSONALIZATION_TYPES.NEW_BUILD:
      return `${CT_PERSONALIZATION_CTA_TEXT.new_build} ${modelName}`;
    case CT_PERSONALIZATION_TYPES.RESUME_BUILD:
      return `${CT_PERSONALIZATION_CTA_TEXT.resume_build} ${modelName}`;
    default:
      return 'Explore';
  }
};
